var newWindow: Window;

export function canOpenBlobFile(): boolean {
  return window.navigator != null && window.navigator.msSaveOrOpenBlob != null;
}

export function openBlobFile(fileBlob: Blob, fileName: string, self: boolean = false): void {
  if (window.navigator != null && window.navigator.msSaveOrOpenBlob != null) { // for IE
    window.navigator.msSaveOrOpenBlob(fileBlob, fileName);
  } else {
    const fileURL = URL.createObjectURL(fileBlob);
    if (newWindow != null) {
      updateWindowUrl(fileURL);
    } else {
      window.open(fileURL, self ? '_self': '_blank');
    }
  }
}



export function openWindow(filename: string = 'loading.html'): Window {
  newWindow = window.open(filename, '_blank');
  return newWindow;
}

export function updateWindowUrl(url: string): void {
  if (newWindow != null) {
    newWindow.location.href = url;
  } else {
    window.location.replace(url);
  }
}

export function resetWindow(): void {
  newWindow = undefined;
}
